import { TsOriginLogo } from "@/components/brand/ts-origin-logo";
import { Button } from "@/components/ui/button";
import { ArrowRight, Mail, MapPin, Phone } from "lucide-react";
import Link from "next/link";

export function Footer() {
  return (
    <footer className="relative overflow-hidden border-t bg-gradient-to-b from-white to-slate-100 dark:from-slate-950 dark:to-slate-900 pt-12 pb-8 sm:px-4 xl:px-8">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-24 left-12 h-56 w-56 rounded-full bg-emerald-400/10 blur-3xl" />
        <div className="absolute -bottom-28 right-8 h-64 w-64 rounded-full bg-sky-400/10 blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-4 space-y-5">
            <TsOriginLogo size="sm" />
            <p className="text-sm text-muted-foreground">Nạp point & quản lý tài khoản</p>
            <p className="text-slate-600 dark:text-slate-400 max-w-xs leading-relaxed">
              Hệ thống nạp point an toàn, hỗ trợ quản lý tài khoản và theo dõi lịch sử giao dịch nhanh chóng.
            </p>
            <div className="flex flex-col gap-2 text-sm text-slate-600 dark:text-slate-400">
              <span>Giờ hỗ trợ: 08:00 - 22:00</span>
              <span>Hotline: 1900 1234</span>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
              <div className="space-y-4">
                <h3 className="text-base font-bold">Liên kết nhanh</h3>
                <ul className="space-y-2">
                  <li>
                    <Link href="/list-account" className="text-slate-600 dark:text-slate-400 hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors">
                      Danh sách tài khoản
                    </Link>
                  </li>
                  <li>
                    <Link href="/pricing" className="text-slate-600 dark:text-slate-400 hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors">
                      Nạp point game
                    </Link>
                  </li>
                  <li>
                    <Link href="/support" className="text-slate-600 dark:text-slate-400 hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors">
                      Trung tâm hỗ trợ
                    </Link>
                  </li>
                  <li>
                    <Link href="/download" className="text-slate-600 dark:text-slate-400 hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors">
                      Tải game
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="space-y-4">
                <h3 className="text-base font-bold">Dịch vụ</h3>
                <ul className="space-y-2">
                  <li className="text-slate-600 dark:text-slate-400">Nạp point nhanh</li>
                  <li className="text-slate-600 dark:text-slate-400">Quản lý tài khoản</li>
                  <li className="text-slate-600 dark:text-slate-400">Theo dõi lịch sử nạp</li>
                  <li className="text-slate-600 dark:text-slate-400">Hỗ trợ kỹ thuật</li>
                </ul>
              </div>

              <div className="space-y-4">
                <h3 className="text-base font-bold">Liên hệ</h3>
                <ul className="space-y-3">
                  <li className="flex items-center gap-2 text-slate-600 dark:text-slate-400">
                    <MapPin className="h-4 w-4 text-emerald-500" />
                    68/12 Nguyễn Trãi, Hà Nội
                  </li>
                  <li className="flex items-center gap-2 text-slate-600 dark:text-slate-400">
                    <Phone className="h-4 w-4 text-emerald-500" />
                    1900 1234
                  </li>
                  <li className="flex items-center gap-2 text-slate-600 dark:text-slate-400">
                    <Mail className="h-4 w-4 text-emerald-500" />
                    support@tsorigin.vn
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 rounded-xl border bg-white/70 p-6 shadow-sm dark:bg-slate-900/60">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:items-center">
            <div>
              <h3 className="text-lg font-semibold">Nhận thông báo ưu đãi nạp point</h3>
              <p className="text-sm text-muted-foreground">Đăng ký email để nhận thông tin khuyến mãi mới nhất.</p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row">
              <input
                type="email"
                placeholder="Nhập email của bạn"
                className="w-full rounded-lg border border-slate-200 bg-slate-50 px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 dark:border-slate-700 dark:bg-slate-900"
              />
              <Button variant={"gradient"}>
                Đăng ký
                <ArrowRight className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-slate-200 pt-6 text-sm text-slate-500 dark:border-slate-800 dark:text-slate-400 md:flex-row">
          <span>© {new Date().getFullYear()} TS Origin PC. All rights reserved.</span>
          <div className="flex flex-wrap items-center gap-4">
            <Link href="#" className="hover:text-emerald-600 transition-colors">
              Chính sách bảo mật
            </Link>
            <Link href="#" className="hover:text-emerald-600 transition-colors">
              Điều khoản dịch vụ
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
